import BraftEditor from 'braft-editor'
import 'braft-editor/dist/index.css';
import "@whalecloud/fdx-theme-fdx/keyboardItem.less";

BraftEditor.prototype['componentName'] = "RichEditor";
export default BraftEditor;



// WEBPACK FOOTER //
// ./src/components/rich-editor/index.tsx